import { getItem, removeItem } from '../../helpers/storage';
import { useHistory } from 'react-router';
import { Analytics } from './../../common/utils/analytics';

export const Logout = () => {
    Analytics.sendEventLogout();
    const history = useHistory();

    if (getItem('originalUser')) {
        removeItem('originalUser');
    }
    removeItem('lqaUser');
    removeItem('user');
    history.push('/');
    history.go(0);
    return null;
};
